import React from 'react';
import { useNavigate } from 'react-router-dom';
import './FirstTimeUserBanner.css';

function FirstTimeUserBanner({ onDismiss }) {
  const navigate = useNavigate();

  const handleGoToProfile = () => {
    navigate('/profile');
    if (onDismiss) {
      onDismiss();
    }
  };

  return (
    <div className="first-time-user-banner">
      <div className="banner-content">
        <div className="banner-icon">👋</div>
        <div className="banner-text">
          <strong>Welcome to RSDashboard!</strong>
          <p>
            To get started, head to your{' '}
            <button onClick={handleGoToProfile} className="link-button">
              Profile Settings
            </button>{' '}
            to connect your Strava account and update your profile information. This will enable automatic activity syncing and unlock all features!
          </p>
        </div>
        <div className="banner-actions">
          {onDismiss && (
            <button onClick={onDismiss} className="btn-dismiss" aria-label="Dismiss">
              ✕
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default FirstTimeUserBanner;
